import axiosInstance from "../config/axios.config";

export const opServiceAPI = async (serviceType, payload, method = null) => {
  let url = `/outpatient/emr/${serviceType}/`;

  if (!method) {
    method = payload?.id ? "PATCH" : "POST";
  }
  if (method === "PATCH") {
    if (!payload?.id) {
      throw new Error("PATCH requires an id in the payload");
    }
    url = `/outpatient/emr/${serviceType}/${payload.id}/`;
  }

  return axiosInstance({
    url,
    method,
    data: payload,
  });
};

export const getAdmissionAPI = async (admissionId) => {
  if (!admissionId) throw new Error("admissionId is required");
  return axiosInstance.get(`/outpatient/admission/${admissionId}/`);
};

export const getServiceAPI = (serviceType, id) =>
  axiosInstance.get(`/outpatient/${serviceType}/${id}/`);
